import React from 'react';
import PropTypes from 'prop-types';
import Done from '@material-ui/icons/Done';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  makeStyles, Button, DialogActions, DialogContent, DialogContentText,
  Box,
  Typography,
} from '@material-ui/core';
import DialogTemplate from 'components/shared/DialogTemplate';
import { Input } from 'components/FormInputs';
import { useFormik } from 'components/shared/Formik';
import { validate } from './validate';

const styles = makeStyles((theme) => ({
  content: {
    minWidth: 300,
  },
  review: {
    marginBottom: theme.spacing(2),
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
}));

const ReplyForm = ({
  isUpdating,
  reviewText,
  initialValues,
  onClose,
  onSave,
}) => {
  const classes = styles();
  const intl = useIntl();
  const formik = useFormik({
    initialValues: {
      body: '',
      ...initialValues,
    },
    validate: validate({ intl }),
    onSubmit: async (values) => {
      return onSave(values);
    },
    validateOnBlur: true,
    validateOnChange: true,
  });

  const {
    values, errors, handleSubmit, handleChange, handleBlur, isSubmitting, pristine, isValid,
  } = formik;

  return (
    <DialogTemplate
      title={(
        <FormattedMessage
          id="Reply"
          defaultMessage="Reply"
        />
      )}
      onClose={onClose}
    >
      <form onSubmit={handleSubmit} noValidate>
        <DialogContent
          className={classes.content}
        >
          <DialogContentText
            className={classes.review}
          >
            {reviewText}
          </DialogContentText>
          <Input
            label={(
              <FormattedMessage
                id="Reply"
                defaultMessage="Reply"
              />
            )}
            maxLength={1000}
            variant="outlined"
            errors={errors}
            name="body"
            value={values.body}
            onChange={handleChange}
            onBlur={handleBlur}
            multiline
            rows={5}
            required
          />
          <Box textAlign="right">
            <Typography variant="body2" color={values.body?.length > 1000 ? 'error' : 'initial'}>
              {(values.body?.length || 0)}/1000
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            disabled={isUpdating || pristine || !isValid || isSubmitting}
            type="submit"
          >
            <Done />
            <FormattedMessage
              id="Reply"
              defaultMessage="Reply"
            />
          </Button>
        </DialogActions>
      </form>
    </DialogTemplate>
  );
};

ReplyForm.propTypes = {
  isUpdating: PropTypes.bool,
  reviewText: PropTypes.string,
  initialValues: PropTypes.shape({}),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default ReplyForm;
